import { Box, styled } from '@mui/material';
import Text from '@components/Text/Text';
import { LabelTagVariantType } from './LabelTag.interface';
import { ColorTypes } from '@customTypes/colors';

export const LabelTagBoxContainer = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'variant' && prop !== 'colorType',
})<{
  variant: LabelTagVariantType;
  colorType: ColorTypes;
}>(({ theme, variant, colorType }) => ({
  padding: theme.spacing(4, 10),
  background:
    variant === 'primary' ? theme.palette[colorType ?? 'primary'].main : 'none',
  border: variant === 'secondary' ? `1px solid` : 'none',
  borderColor:
    variant === 'secondary'
      ? theme.palette[colorType ?? 'primary'].main
      : 'none',
  display: 'inline-flex',
  borderRadius: theme.spacing(5),
}));

export const LabelTagText = styled(Text, {
  shouldForwardProp: (prop) => prop !== 'themeVariant' && prop !== 'colorType',
})<{
  themeVariant: LabelTagVariantType;
  colorType: ColorTypes;
}>(({ theme, themeVariant, colorType }) => ({
  color:
    themeVariant === 'primary'
      ? theme.palette.primary.contrastText
      : theme.palette[colorType ?? 'primary'].main,
}));
